import { Icon } from 'vant';
import { defineComponent } from 'vue';
export default defineComponent({
  inheritAttrs: false,
  components: {
    [Icon.name]: Icon
  }
});